import { render, staticRenderFns } from "./ChimelongOrderConnection.vue?vue&type=template&id=5807c28a&scoped=true"
import script from "./ChimelongOrderConnection.vue?vue&type=script&lang=js"
export * from "./ChimelongOrderConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5807c28a",
  null
  
)

export default component.exports